import React, { Suspense, lazy, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { ThemeProvider } from "@emotion/react";
import { Slide, ToastContainer } from "react-toastify";
import { MAVIZ_THEME, ThemeProvider as UIThemeProvider } from "@bale/ui";
import { BreakPointProvider } from "components/context/BreakPointContext";
import Login from "components/content/login/Login";
import { fixAppLayoutSize } from "./utils/layout";
import RedirectLoader from "RedirectLoader";
import YandexMetrica from "./yandex/YandexWrapper";
import LuckyPage from "components/content/LuckyPage/LuckyPage";

const MainPage = lazy(() => import("components/Main" /* webpackChunkName: "MainPage" */));

const App = () => {
  useEffect(() => {
    fixAppLayoutSize();
  }, []);
  return (
    <div className="App">
      <YandexMetrica />
      <BreakPointProvider>
        <UIThemeProvider theme={MAVIZ_THEME}>
          <ThemeProvider theme={MAVIZ_THEME}>
            <Suspense fallback={<div />}>
              <Routes>
                <Route element={<Login />} path="/login" />
                <Route path="/redirecting" element={<RedirectLoader />} />
                <Route path="/luckyPage" element={<LuckyPage />} />
                <Route
                  path="/"
                  element={
                    <Suspense fallback={<div />}>
                      <MainPage />
                    </Suspense>
                  }
                />
                <Route path="*" element={<MainPage />} />
              </Routes>
              <ToastContainer
                position="bottom-center"
                autoClose={2000}
                transition={Slide}
                hideProgressBar
                rtl
              />
            </Suspense>
          </ThemeProvider>
        </UIThemeProvider>
      </BreakPointProvider>
    </div>
  );
};

export default App;
